import bookAnimation from './animations/book-flipping-animation.json';
import burgerCloseDark from './animations/burger-close-5D6A81.json';
import burgerCloseWhite from './animations/burger-close-white.json';
import citeLoadingAnimation from './animations/cite-loading-animation.json';
import expandCollapseDark from './animations/expand-collapse-5D6A81.json';
import expandCollapseWhite from './animations/expand-collapse-white.json';
import flippingBookAnimation from './animations/flipping-book.json';
import animatedLogo from './animations/logo-animation.json';
import searchIcon from './animations/search-icon.json';
import { ControlledLottie, ControlledLottieProps } from './controlled-lottie';

export const ExpandCollapseLottie = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'expand' | 'collapse'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      height={18}
      width={18}
      {...divProps}
      viewBoxSize={'0 3 18 18'}
      stateFrames={[
        { state: 'expand', segment: [0, 4] },
        { state: 'collapse', segment: [7, 11] },
      ]}
      animationData={
        props.color === 'white' ? expandCollapseWhite : expandCollapseDark
      }
    />
  );
};

export const BurgerCloseLottie = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'burger' | 'close'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      {...divProps}
      height={18}
      viewBoxSize={'0 0 400 400'}
      speed={2}
      stateFrames={[
        { state: 'close', segment: [8, 35] },
        { state: 'burger', segment: [52, 71] },
      ]}
      animationData={
        props.color === 'white' ? burgerCloseWhite : burgerCloseDark
      }
    />
  );
};

export const PlagiarismLottie = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'canvas'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      stateFrames={[{ state: 'canvas', segment: [0, 180] }]}
      {...divProps}
      loop={true}
      path="https://cdn.paperpal.com/assets/lottie-animation/edit/plagiarism-canvas-lottie.json"
    />
  );
};

export const FlippingBookLottie = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'canvas'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      stateFrames={[{ state: 'canvas', segment: [0, 180] }]}
      {...divProps}
      loop={true}
      animationData={flippingBookAnimation}
    />
  );
};

export const AnimatedLogoLottie = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'canvas'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      stateFrames={[{ state: 'canvas', segment: [0, 80] }]}
      {...divProps}
      loop={true}
      animationData={animatedLogo}
    />
  );
};

export const BookAnimation = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'canvas'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      stateFrames={[{ state: 'canvas', segment: [0, 220] }]}
      {...divProps}
      loop={true}
      animationData={bookAnimation}
    />
  );
};

export const SearchAnimationIcon = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'canvas'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      stateFrames={[{ state: 'canvas', segment: [0, 220] }]}
      {...divProps}
      loop={true}
      animationData={searchIcon}
    />
  );
};

export const CiteLoadingAnimation = (
  props: { color: 'white' | 'dark' } & Omit<
    Omit<ControlledLottieProps<'canvas'>, 'animationData'>,
    'stateFrames'
  >,
) => {
  const { color, ...divProps } = props;
  return (
    <ControlledLottie
      stateFrames={[{ state: 'canvas', segment: [0, 220] }]}
      {...divProps}
      loop={true}
      animationData={citeLoadingAnimation}
    />
  );
};
